import React from 'react';
import { CategoryChoice } from '@scale/shared/types/params/textcollection';
import { categoryChoiceSchema } from '@scale/shared/taskTemplate/textCollectionSchemas';
import ArrayBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ArrayBuilder';
import { Button } from '@scale/scaleui';
import type { TypeBuilderMapType } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemasType';

interface CategoryChoicesBuilderProps {
  name: string;
  existingValue?: Array<CategoryChoice>;
  updateProperty: (arg: Array<CategoryChoice> | undefined) => void;
  required?: boolean;
  typeBuilderMap: TypeBuilderMapType;
}

const CategoryChoicesBuilder: React.FC<CategoryChoicesBuilderProps> = ({
  name,
  existingValue = [],
  updateProperty,
  typeBuilderMap,
}) => {
  const choices = existingValue;

  const addChoice = () => {
    const newChoices = [...choices];
    const valuePlaceholder = `choice_${choices.length + 1}`;
    newChoices.push({
      label: valuePlaceholder,
      value: valuePlaceholder,
    });
    updateProperty(newChoices);
  };

  return (
    <div className="flex flex-col">
      <div className="mb-1">{name}</div>
      <div className="mb-1">
        <ArrayBuilder
          typeBuilderMap={typeBuilderMap}
          elements={choices}
          setElements={updateProperty}
          getKey={choice => choice.label}
          getTitle={choice => choice.label}
          getSchema={_ => categoryChoiceSchema}
        />
      </div>
      <div>
        <Button size="sm" onClick={() => addChoice()}>
          Add Choice
        </Button>
      </div>
    </div>
  );
};

export default CategoryChoicesBuilder;
